import request from '@/utils/request'

/**
 * 电耗趋势图获取
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function electricConsumeGet(data) {
  return request({
    type: 'device',
    url: 'electric/consume/get',
    method: 'post',
    data
  })
}

/**
 * 水耗趋势图获取
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function waterConsumeGet(data) {
  return request({
    type: 'device',
    url: 'water/consume/get',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/WaterElectric.js